import { Component, Prop, Vue } from 'vue-property-decorator';
import { Action } from 'vuex-class';

import CardHeader from '@/components/Includes/CardHeader/CardHeader.vue';
import IReceipt from '@/interfaces/IReceipt';

import ReceiptForm from '../ReceiptForm/ReceiptForm.vue';

@Component({
    name: 'ReceiptDetail',
    components: {
        CardHeader,
        ReceiptForm
    }
})
export default class ReceiptDetail extends Vue {
    @Prop(Object) private receiptData!: IReceipt | undefined;

    @Action private getReceipt!: (id: string) => Promise<IReceipt>;

    private receiptDataFromBackend: IReceipt | null = null;

    private get receiptId() {
        return this.$route.params.id;
    }

    private get formReceiptData() {
        return this.receiptDataFromBackend || this.receiptData
    }

    private async mounted() {
        try {
            if (!this.receiptData) {
                this.receiptDataFromBackend = await this.getReceipt(this.receiptId);
            }
        } catch {
            return void 0;
        }
    }
}
